import { Component, OnInit } from '@angular/core';
import { GenerateRouteService } from 'src/app/common/service/generate-route.service';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss'
})
export class FaqsComponent implements OnInit {

  faqs: {
    question: string,
    answer: string,
    isHidden: boolean
  }[] = [];

  constructor(
    private generateRouteService: GenerateRouteService
  ) { }

  ngOnInit(): void {
    this.faqs = [
      { question: 'faqs_Data1', answer: 'faqs_Data2', isHidden: true },
      { question: 'faqs_Data3', answer: 'faqs_Data4', isHidden: true },
      { question: 'faqs_Data5', answer: 'faqs_Data6', isHidden: true },
      { question: 'faqs_Data7', answer: 'faqs_Data8', isHidden: true },
    ];
  }

  /**
   * Expande la pregunta
   * @param faq
   */
  expand(faq: { isHidden: boolean }): void {
    faq.isHidden = !faq.isHidden;
  }

  /**
   * Obtiene la ruta en el idioma actual
   * @param routeKey
   * @returns
   */
  getRouterLink(routeKey: any): string {
    return this.generateRouteService.generateRoute(routeKey);
  }
}
